import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '@assets/img/dice-game/materials.svg?react';
import ResourceIcon from '@assets/img/dice-game/resource.svg?react';

import { TickerInner } from '@/components/common/Ticker/TickerInner';
import { StringMain } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import characterPng from '/img/characters/lumberjack-char-small.png';
import characterWebp from '/img/characters/lumberjack-char-small.webp';
import cashPng from '/img/icons/cash-large.png';
import cashWebp from '/img/icons/cash-large.webp';

const GameItemInfo: FC = () => {
  const { t } = useTranslation();

  const items = ['cash', 'resource', 'materials'];

  return (
    <div className={css.gameItemInfo}>
      <TickerInner
        className="text-accent italic absolute top-0 right-0"
        variant="black-30-main"
        text="xs-medium"
        label={t('Drop all time')}
      />
      <StringMain weight="bold" className="!leading-1.2 relative z-[2]">
        {t('Cash, Resources & Materials')}
      </StringMain>
      <div className="flex gap-1 relative z-[2]">
        {items.map((item) => (
          <div
            key={item}
            className="w-14 h-14 shrink-0 rounded-lg bg-black/60 flex items-center justify-center backdrop-blur-sm"
          >
            {item === 'cash' && (
              <Picture
                className="inline-block w-[2.8rem] aspect-square"
                img={cashPng}
                webp={cashWebp}
                alt="cash"
              />
            )}
            {item === 'resource' && <ResourceIcon className="w-12 h-12" />}
            {item === 'materials' && <MaterialIcon className="w-13 h-13" />}
          </div>
        ))}
      </div>
      <Picture
        className="aspect-[420/480] w-[111px] -scale-x-[1] absolute right-6 top-6"
        img={characterPng}
        webp={characterWebp}
        alt="character"
      />
      <div className={css.ellipse}></div>
    </div>
  );
};

export { GameItemInfo };
